/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_P2dInputs */

const en_mk_sol_konsultan_p2d = /** @type {(inputs: Mk_Sol_Konsultan_P2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“We have done something like this before” is often true, but finding the file takes half a day.`)
};

const id_mk_sol_konsultan_p2d = /** @type {(inputs: Mk_Sol_Konsultan_P2dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"Kita pernah mengerjakan yang seperti ini" sering benar, tapi menemukan berkasnya butuh setengah hari.`)
};

/**
* | output |
* | --- |
* | "“We have done something like this before” is often true, but finding the file takes half a day." |
*
* @param {Mk_Sol_Konsultan_P2dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_p2d = /** @type {((inputs?: Mk_Sol_Konsultan_P2dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_P2dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_p2d(inputs)
	return en_mk_sol_konsultan_p2d(inputs)
});